// extracted by mini-css-extract-plugin
export var formContainer = "_fp-0";
export var message = "_fp-1";